module.exports = __webpack_public_path__ + "img/commander13.png";